const ChevronRightIcon = () => (
  <svg style={{ width: 14, height: 14, flexShrink: 0 }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
  </svg>
);

const ChevronLeftIcon = () => (
  <svg style={{ width: 14, height: 14, flexShrink: 0 }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
  </svg>
);

const BTN_SIZE = 32;
const BTN_FONT = 12;

const baseStyle = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  width: BTN_SIZE,
  height: BTN_SIZE,
  minWidth: BTN_SIZE,
  minHeight: BTN_SIZE,
  borderRadius: 8,
  border: "0.5px solid",
  fontSize: BTN_FONT,
  fontWeight: 500,
  flexShrink: 0,
  cursor: "pointer",
  transition: "background 120ms, border-color 120ms, color 120ms",
  boxSizing: "border-box",
  userSelect: "none",
  lineHeight: 1,
};

const Pagination = ({ page, totalPages, onPageChange }) => {
  if (totalPages <= 1) return null;

  const items = [];
  for (let p = 1; p <= totalPages; p++) {
    const show = p === 1 || p === totalPages || Math.abs(p - page) <= 1;
    const ellipsisBefore = p === page - 2 && p > 2;
    const ellipsisAfter = p === page + 2 && p < totalPages - 1;

    if (ellipsisBefore || ellipsisAfter) {
      items.push({ type: "ellipsis", key: `e${p}` });
    } else if (show) {
      items.push({ type: "page", value: p, key: p });
    }
  }

  const navStyle = (disabled) => ({
    ...baseStyle,
    background: disabled ? "#f9fafb" : "#ffffff",
    borderColor: "#e5e7eb",
    color: disabled ? "#d1d5db" : "#6b7280",
    cursor: disabled ? "not-allowed" : "pointer",
  });

  const pillStyle = (active) => ({
    ...baseStyle,
    background: active ? "#4f46e5" : "#ffffff",
    borderColor: active ? "#4f46e5" : "#e5e7eb",
    color: active ? "#ffffff" : "#4b5563",
  });

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 6,
        flexWrap: "nowrap",
      }}
    >
      <button
        type="button"
        onClick={() => onPageChange(page - 1)}
        disabled={page <= 1}
        style={navStyle(page <= 1)}
        aria-label="עמוד קודם"
      >
        <ChevronRightIcon />
      </button>

      {items.map((item) =>
        item.type === "ellipsis" ? (
          <span
            key={item.key}
            style={{
              width: BTN_SIZE,
              minWidth: BTN_SIZE,
              textAlign: "center",
              fontSize: BTN_FONT,
              color: "#d1d5db",
              flexShrink: 0,
              userSelect: "none",
            }}
          >
            …
          </span>
        ) : (
          <button
            key={item.key}
            type="button"
            onClick={() => onPageChange(item.value)}
            style={pillStyle(item.value === page)}
          >
            {item.value}
          </button>
        )
      )}

      <button
        type="button"
        onClick={() => onPageChange(page + 1)}
        disabled={page >= totalPages}
        style={navStyle(page >= totalPages)}
        aria-label="עמוד הבא"
      >
        <ChevronLeftIcon />
      </button>
    </div>
  );
};

export default Pagination;